import React, { CSSProperties, FC } from 'react';
import clsx from 'clsx';
import { getIconNameByFileExt } from '../../services/utils';
import { Icon } from '../Core/Icon';
import { iconComponents } from 'components/Core/IconImports';

interface FileIconProps {
  fileExtension: string;
  isFolder?: boolean;
  isShortcut?: boolean;
  showExtension?: boolean;
  style?: CSSProperties | null;
  className?: string;
  iconClassName?: string;
  shortcutIconClassName?: string;
  onClick?: () => void;
}

const FileIcon: FC<FileIconProps> = ({
  fileExtension,
  isFolder = false,
  isShortcut = false,
  showExtension = false,
  style = null,
  className = '',
  iconClassName = '',
  shortcutIconClassName = '',
  onClick,
}) => {
  return (
    <div
      className={clsx(
        'file-icon relative flex items-center justify-center',
        isFolder && 'text-[#FFB900]',
        className
      )}
      style={{ ...style }}
      onClick={onClick}
    >
      {isShortcut && (
        <Icon
          name="ExternalLinkIcon"
          className={clsx(
            'absolute text-blue-dark',
            shortcutIconClassName
              ? shortcutIconClassName
              : 'bottom-0 left-3 h-3 w-3'
          )}
        />
      )}

      <Icon
        name={
          isFolder
            ? 'IconFolder'
            : (getIconNameByFileExt(fileExtension)
                ?.icon as keyof typeof iconComponents)
        }
        className={clsx('h-full w-full', iconClassName)}
      />
      {showExtension && (
        <div
          className="absolute bottom-0 right-1 rounded-md px-1.5 text-xs text-white"
          style={{
            backgroundColor: getIconNameByFileExt(fileExtension)?.color,
          }}
        >
          {fileExtension}
        </div>
      )}
    </div>
  );
};

export default FileIcon;
